import { Mediator, app } from "modular-openscriptjs";
import { eParse } from "../helpers";
import { gc } from "../declarations";

const $e = app("$e");

export class QRCode extends Mediator {
	$$qr = {
		needs: {
			scan: (ed, event) => {
				this.send($e.qr.needs.scanForm);
			},
			resultHandling: (ed, event) => this.handleScanResult(ed, event),
		},
		has: {
			visibleForm: (ed, event) => this.scan(ed, event),
		},
	};

	scan(ed, event) {
		gc.qrScanner.start();
	}

	handleScanResult(ed, event) {
		const { message } = eParse(ed);

		gc.qrScanner.stop();
		let path = message.get("result")?.data;
		let qs = {};

		this.send($e.qr.has.scanResult);

		if (app("router").isQualifiedUrl(path)) {
			let url = new URL(path);

			if (url.origin == app("router").url().origin) {
				path = url.pathname;
				qs = Object.fromEntries(url.searchParams);
			}
		}

		app("router").to(path, qs);
	}
}
